import React, { useContext } from "react";

import {
  ModalContainer,
  ModalContainerBodyContainer,
  ModalContainerBody,
} from "./styled";

import { CoreContext } from "context/CoreContext";
import ModalRestartCampaign from "../RestartCampaign";

export default function ModalRestart() {
  const { modal, setModal } = useContext(CoreContext);

  const close = () => {
    setModal(null);
  };

  return (
    <>
      <ModalContainer>
        <ModalContainerBodyContainer>
          <ModalContainerBody>
            <ModalRestartCampaign
              closeable={close}
              campaign={modal?.item?.campaign}
              reload={modal?.reload}
            />
          </ModalContainerBody>
        </ModalContainerBodyContainer>
      </ModalContainer>
    </>
  );
}
